import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header__container">
        <div className="header__logo" onClick={() => scrollToSection('hero')}>
          <span className="header__logo-text">営業・採用研修</span>
        </div>

        <nav className={`header__nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <button className="header__nav-item" onClick={() => scrollToSection('problem')}>
            課題
          </button>
          <button className="header__nav-item" onClick={() => scrollToSection('solution')}>
            ソリューション
          </button>
          <button className="header__nav-item" onClick={() => scrollToSection('results')}>
            実績
          </button>
          <button className="header__nav-item" onClick={() => scrollToSection('services')}>
            事業領域
          </button>
          <button className="header__nav-item" onClick={() => scrollToSection('profile')}>
            プロフィール
          </button>
          <button 
            className="header__cta-button"
            onClick={() => scrollToSection('cta')}
          >
            無料相談
          </button>
        </nav>

        <button 
          className="header__mobile-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="メニュー"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
